import React, { useState } from "react";
import { Mode } from "../../components/ReadWriteTextField";
import { useAuthContext } from "../../AuthContextWrapper"
import { UserInfo } from "./UserInfo"
import { useEstateUserContext } from "../../EstateUserContextWrapper"
import { Grid, Typography, Button } from "@mui/material";
import { User } from "models/User";
import { UserProfile } from "models/UserProfile";

interface IProps {
  allowedModes?: Mode[],
  startMode?: Mode,
}

export function BeneficiariesInfo(props: IProps): JSX.Element {
  const { user } = useAuthContext()
  const { usersInActiveEstate, setUsersInActiveEstate } = useEstateUserContext()
  const [addingBeneficiary, setAddingBeneficiary] = useState<User | undefined>()
  const editAllowed = !props.allowedModes || props.allowedModes.length == 0 || !!props.allowedModes?.find(m => m == "edit")

  function onSaveUser(u: User) {
    const newUsersInActiveEstate = [...(usersInActiveEstate || [])]
    const userInGroupIndex = newUsersInActiveEstate.findIndex(userInEstate => {
      return !!u.id && userInEstate.id == u.id
    })
    if (userInGroupIndex >= 0) {
      newUsersInActiveEstate[userInGroupIndex] = u
    } else {
      newUsersInActiveEstate.push(u)
    }

    setUsersInActiveEstate(newUsersInActiveEstate)
  }


  return <>
    <Grid container style={{ marginBottom: "1rem" }}>
      <Grid item xs={12} sm={3} md={3} lg={3} xl={3}>
        <Typography variant="h3" component="div">Beneficiaries</Typography>
      </Grid>
      <Grid item xs={12} sm={5} md={5} lg={5} xl={5}>&nbsp;</Grid>
      <Grid item xs={12} sm={4} md={4} lg={4} xl={4} style={{ display: "flex", alignContent: "flex-end", alignItems: "flex-end", justifyContent: "flex-end" }}>
        <div style={{ width: "200px" }}>
          <Button
            disabled={!!addingBeneficiary}
            variant="outlined"
            color="primary"
            onClick={() => {
              const newUser = new User()
              newUser.profile = new UserProfile()
              setAddingBeneficiary(newUser)
            }}
          >+ Add Beneficiary</Button>
        </div>
      </Grid>
    </Grid>
    {(!!usersInActiveEstate && user?.id) && usersInActiveEstate.map((userInEstate) => {
      if (userInEstate.id == user.id) {
        return
      }

      return <div style={{ marginBottom: "1rem" }}>
        <UserInfo
          headerIsUsername={true}
          clickHeaderToHideContents={true}
          key={userInEstate.id}
          user={userInEstate}
          setUser={user => {
            onSaveUser(user)
          }}
          startMode={"read"}
          allowedModes={props.allowedModes}
          autofocusFirstName={true}
          onSave={onSaveUser}
        />
      </div>
    })}
    {!!addingBeneficiary && <UserInfo
      headerIsUsername={true}
      key={"newbeneficiary" + (addingBeneficiary ? addingBeneficiary.id : "")}
      user={addingBeneficiary}
      setUser={user => {
        setAddingBeneficiary(user)
      }}
      startMode={editAllowed ? "edit" : "read"}
      allowedModes={props.allowedModes}
      autofocusFirstName={true}
      onSave={user => {
        onSaveUser(user)
        setAddingBeneficiary(undefined)
      }}
      onCancelBeforeSave={() => {
        setAddingBeneficiary(undefined)
      }}
    />}
  </>

}